import React from "react";
import {CheckBarChart} from "../components/CheckBarChart";
import {CheckTotals} from "../components/CheckTotals";
import DepositsPieChart from "../components/DepositsPieChart"
import Grid from '@mui/material/Grid2';
import CheckLineChart from "../components/CheckLineChart";
import {Box} from "@mui/material";

export function Dashboard() {
    return (
        <>
            <title>Dashboard</title>
            <Box
                sx={{
                    display: "grid",
                    alignContent: "flex-start",
                    background: "transparent",
                    width: "100%",
                    height: "100%",
                    padding: 0,
                }}
            >
                <Grid container spacing={1} minWidth={300}>
                    <Grid size={{xs: 12, lg: 6}} sx={{height: "calc(50vh - 12px)", minHeight: "250px"}}>
                        <CheckBarChart/>
                    </Grid>
                    <Grid size={{xs: 12, lg: 6}} sx={{height: "calc(50vh - 12px)", minHeight: "250px"}}>
                        <CheckTotals/>
                    </Grid>
                    <Grid size={{xs: 12, lg: 6}} sx={{height: "calc(50vh - 12px)", minHeight: "250px"}}>
                        <DepositsPieChart/>
                    </Grid>
                    <Grid size={{xs: 12, lg: 6}} sx={{height: "calc(50vh - 12px)", minHeight: "250px"}}>
                        <CheckLineChart/>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}